import React, { PropsWithChildren } from 'react'

import { type IconProps } from './icon.type'

export const WithIcon = ({
  icon,
  position = 'left',
  children,
}: PropsWithChildren<{
  icon: React.ReactNode
  position: IconProps['position']
}>) => {
  const leftIcon = position === 'left' ? icon : null
  const rightIcon = position === 'right' ? icon : null
  return (
    <>
      {leftIcon}
      {children}
      {rightIcon}
    </>
  )
}
